import { typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.mjs';

function createStore(createState) {
  var state;
  var listeners = new Set();
  var setState = function setState(partial) {
    var nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      var previousState = state;
      state = _typeof(nextState) !== "object" || nextState === null ? nextState : Object.assign({}, state, nextState);
      listeners.forEach(function (listener) {
        return listener(state, previousState);
      });
    }
  };
  var getState = function getState() {
    return state;
  };
  var subscribe = function subscribe(listener) {
    listeners.add(listener);
    return function () {
      return listeners["delete"](listener);
    };
  };
  var getInitialState = function getInitialState() {
    return initialState;
  };
  var api = {
    setState: setState,
    getState: getState,
    subscribe: subscribe,
    getInitialState: getInitialState
  };
  var initialState = state = createState(setState);
  return api;
}

export { createStore };
